import gql from 'graphql-tag'

export const GET_MESSAGES = gql`
  query getAllMessages {
    getAllMessages {
      id
      title
      type
      isActive
      description
      imageUrl
      createdAt
      updatedAt
    }
  }
`

export const GET_BIRTHDAY_LOGS = gql`
  query getBirthdayLogs {
    getBirthdayLogs {
      id
      userId
      name
      code
      username
      birthDate
      emailSent
      sentTimestamp
      popupVisited
      visitedTimestamp
    }
  }
`

export const CHECK_BIRTHDAY_POPUP_STATUS = gql`
  query checkBirthdayPopupStatus {
    checkBirthdayPopupStatus {
      showModal
      imageUrl
      title
      description
    }
  }
`
